
import { create } from "zustand"

export const useInterestPointStore = create((set, get) => ({
  activeInterestPointId: null,
  setActiveInterestPointId: (id) => set({ activeInterestPointId: id }),

  points: {},
  initInterestPoints: (interestPoints) => {
    if (!Array.isArray(interestPoints)) return
    const prev = get().points
    const next = { ...prev }

    for (const point of interestPoints) {
      const pointId = point.id
      if (pointId == null) continue
      if (!next[pointId]) next[pointId] = { visited: false }
    }
    set({ points: next })
  },

  markVisited: (id) => {
    if (id == null) return
    const prev = get().points
    if (prev[id]?.visited) return

    set({
      points: {
        ...prev,
        [id]: { visited: true }
      }
    })
  }

}))
